module.exports = __webpack_public_path__ + "static/Classroom-Activity-2-4-Bullying-in-Our-School-What-Can-We-Do-ES-4cd889c38c105cd5eb09786fa49cc3c8.pdf";